import { normalizeEmail } from "@/shared/utils/email";
const SIGNUP_SUCCESS_PENDING_KEY = "signup-success-pending";

export type SignUpMethod = "email" | "google";

interface SignUpSuccessPending {
	email: string;
	method: SignUpMethod;
}

export const markSignUpSuccessPending = (email: string, method: SignUpMethod = "email") => {
	sessionStorage.setItem(
		SIGNUP_SUCCESS_PENDING_KEY,
		JSON.stringify({ email: normalizeEmail(email), method } satisfies SignUpSuccessPending),
	);
};

export const getSignUpSuccessPending = (email: string): SignUpSuccessPending | null => {
	const value = sessionStorage.getItem(SIGNUP_SUCCESS_PENDING_KEY);
	if (!value) return null;

	try {
		const pending = JSON.parse(value) as Partial<SignUpSuccessPending>;
		if (pending.email === normalizeEmail(email) && (pending.method === "email" || pending.method === "google")) {
			return pending as SignUpSuccessPending;
		}
	} catch {
		// Preserve pending state written by the previous email-only format.
		if (value === normalizeEmail(email)) return { email: value, method: "email" };
	}

	return null;
};

export const isSignUpSuccessPending = (email: string) => Boolean(getSignUpSuccessPending(email));

export const clearSignUpSuccessPending = () => {
	sessionStorage.removeItem(SIGNUP_SUCCESS_PENDING_KEY);
};
